import { __assign, __rest } from "tslib";
import React from 'react';
import { easeInOut } from '../utils/curves';
import { largeDurationMs } from '../utils/durations';
import KeyframesMotion from './keyframes-motion';
var entranceMotions = {
    bottom: 'translate3d(0, calc(5% + 4px), 0)',
    left: 'translate3d(calc(-5% - 4px), 0, 0)',
    right: 'translate3d(calc(5% + 4px), 0, 0)',
    top: 'translate3d(0, calc(-5% - 4px), 0)',
};
var exitMotions = {
    bottom: 'translate3d(0, calc(-5% - 4px), 0)',
    left: 'translate3d(calc(5% + 4px), 0, 0)',
    right: 'translate3d(calc(-5% - 4px), 0, 0)',
    top: 'translate3d(0, calc(5% + 4px), 0)',
};
export var fadeInAnimation = function (movement) {
    return {
        from: __assign({ opacity: 0 }, (movement !== undefined && {
            transform: entranceMotions[movement],
        })),
        '50%': {
            opacity: 1,
        },
        to: {
            transform: movement !== undefined ? 'none' : undefined,
        },
    };
};
export var fadeOutAnimation = function (movement) { return ({
    from: {
        opacity: 1,
        transform: movement !== undefined ? 'translate3d(0, 0, 0)' : undefined,
    },
    to: __assign({ opacity: 0 }, (movement !== undefined && {
        transform: exitMotions[movement],
    })),
}); };
var FadeIn = function (_a) {
    var children = _a.children, _b = _a.duration, duration = _b === void 0 ? largeDurationMs : _b, entranceSlideDirection = _a.entranceDirection, props = __rest(_a, ["children", "duration", "entranceDirection"]);
    return (React.createElement(KeyframesMotion, __assign({ duration: duration, enteringAnimation: fadeInAnimation(entranceSlideDirection), exitingAnimation: fadeOutAnimation(entranceSlideDirection), animationTimingFunction: function () { return easeInOut; } }, props), children));
};
export default FadeIn;
//# sourceMappingURL=fade-in.js.map